// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isEqual from "lodash/isEqual";
import React, { createContext, useState } from "react";

export const PopupContext = createContext<any>({});

const options = {
    openTime: 300,
    closeTime: 1000,
};

const PopupContextProvider: React.FC<any> = ({ opened, children }) => {
    const [current, doTheSetCurrent] = useState<number[]>([]);
    let openTimeout: any;
    let closeTimeout: any;

    const doSetCurrent = (value: number[]) => {
        if (!isEqual(value.sort(), current.sort())) {
            doTheSetCurrent(value);
        }
    };

    const registerOpen = (state: number[]) => {
        if (!current.length) {
            clearTimeout(openTimeout);
            openTimeout = setTimeout(() => doSetCurrent(state), options.openTime);
        } else {
            clearTimeout(openTimeout);
            clearTimeout(closeTimeout);
            doSetCurrent(state);
        }
    };

    const registerClose = (state: number[], time = 0) => {
        clearTimeout(openTimeout);
        clearTimeout(closeTimeout);

        current.length && (closeTimeout = setTimeout(() => doSetCurrent(state), time || options.closeTime));
    };

    const setCurrent = (state: number[]) => {
        clearTimeout(openTimeout);
        clearTimeout(closeTimeout);

        doSetCurrent(state);
    };

    const closeAllPopups = () => {
        registerClose([], 150);
    };

    return (
        <PopupContext.Provider value={{ current, setCurrent, registerOpen, registerClose, closeAllPopups }}>
            {children}
        </PopupContext.Provider>
    );
};
export default PopupContextProvider;
